<div class="section-container" *ngIf="nonFocusedSections$ | async as sections">
  <div class="leftPad" [style.width]="sections[0]"></div>
  <div class="leftBracket"></div>

  <div class="focusArea" [style.width]="sections[1]"></div>

  <div class="rightBracket"></div>
  <div class="rightPad" [style.width]="sections[2]"></div>
</div>
